import { Form, Input, InputNumber, Modal, Upload } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { upLoadImage } from '../../services/postservice'
import openNotification from '../common/Notification/openNotification '
import styles from './styles.module.scss'

const { TextArea } = Input

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const FormPost = ({ form, mode }) => {
  const [fileList, setFileList] = useState([])
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState()
  const [previewTitle, setPreviewTitle] = useState()

  const logo = Form.useWatch('logo', form)

  useEffect(() => {
    if (logo) {
      setFileList([
        {
          uid: '-1',
          name: 'logo',
          status: 'done',
          url: logo
        }
      ])
    } else {
      setFileList([])
    }
  }, [logo])

  const handleChange = ({ fileList: nextFileList }) => {
    setFileList(nextFileList)
  }

  const handlePreview = async (file) => {
    if (file.response) {
      setPreviewImage(file.response?.[0]?.link)
      setPreviewVisible(true)
      setPreviewTitle(false)
    } else {
      setPreviewImage(file.url)
      setPreviewVisible(true)
      setPreviewTitle(false)
    }
  }

  const handleCancel = () => {
    setPreviewVisible(false)
  }

  const handleCustomRequest = async (options) => {
    const { file, onSuccess, onError, onProgress } = options

    const formData = new FormData()
    formData.append('file_image', file)

    try {
      const response = await upLoadImage(formData)

      if (response?.data?.[0]?.link) {
        form.setFieldValue('logo', response.data[0].link)
      }

      if (onProgress) {
        onProgress({ percent: 100 })
      }

      onSuccess(response.data, file)
    } catch (error) {
      onError(error)
      openNotification('error', 'upload thất bại')
    }
  }

  const UploadButton = () => (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  )

  return (
    <Form
      form={form}
      labelAlign="left"
      labelCol={{ span: 6 }}
      layout="vertical"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      disabled={mode === 'VIEW'}
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>

      <Form.Item
        name="logo"
        label="Logo"
        rules={[{ required: true, message: 'Vui lòng tải logo' }]}
        className={styles.formItem}
      >
        <Upload
          accept="image/*"
          customRequest={handleCustomRequest}
          onChange={handleChange}
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          multiple={false}
          maxCount={1}
        >
          {fileList.length < 1 && <UploadButton />}
        </Upload>
        <Modal
          open={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img alt="preview" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Form.Item>

      <Form.Item
        label="Tên nhãn hàng"
        name="partner_name"
        rules={[{ required: true, message: 'Vui lòng nhập tên nhãn hàng' }]}
        className={styles.formItem}
      >
        <Input placeholder="Nhập tên nhãn hàng" />
      </Form.Item>

      <Form.Item
        label="Mô tả"
        name="partner_description"
        rules={[{ required: true, message: 'Vui lòng nhập mô tả' }]}
        className={styles.formItem}
      >
        <TextArea rows={4} placeholder="Nhập mô tả" />
      </Form.Item>

      <Form.Item
        label="Đường link đối tác"
        name="partner_link"
        rules={[{ required: true, message: 'Vui lòng nhập đường link đối tác' }]}
        className={styles.formItem}
      >
        <Input placeholder="Nhập đường link đối tác" />
      </Form.Item>

      <Form.Item
        label="Order"
        name="display_order"
        rules={[{ required: true, message: 'Vui lòng nhập thứ tự' }]}
        className={styles.formItem}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>
    </Form>
  )
}

export default FormPost
